export default {"src":"/_next/static/media/no_image.9f2d0a75.svg","height":381,"width":318,"blurWidth":0,"blurHeight":0};